var DiagnosticQuestion = function () {
	var diagnosticQuestion = function () {
		var questionBlock = $('.self-diagnostic-question-block');

		$('.self-diagnostic-question-ajax-btn').click(function (event) {
			event.preventDefault();
			var thelink = $(this);
			var href = thelink.data('url') || thelink.attr('href');

			$.ajax({
				url: href,
				type: 'GET',
				data: {
					content: $(this).data('content'),
					vote: $(this).data('vote')
				},
				success: function (data) {
					questionBlock.html(data);
					init();
				},
				error: function () {
					console.log("self-diagnostic error");
				}
			});
		});
	};

	var init = function () {
		diagnosticQuestion();
	};

	return {
		init: init
	};
}();

UL.register(DiagnosticQuestion);
